module.exports = __webpack_public_path__ + "img/eg2.d2295f34.png";